import Vue from 'vue'
import VueRouter from 'vue-router'
import { applyRouteSeo } from '@/utils/seo'
import LandingView from '../views/LandingView.vue'
import PageView from '../views/PageView.vue'
import NotFound404View from '@/views/NotFound404View'
import LogoutView from '@/views/authentication/LogoutView'
import ForgotPasswordView from '@/views/password/ForgotPasswordView'
import ResetPasswordView from '@/views/password/ResetPasswordView'
import VerifyView from '@/views/authentication/VerifyView'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: LandingView,
    meta: {
      title: 'Jobs, talent & local services',
      documentTitle: 'Workmorr — Jobs, talent & local services | Hire & get hired',
      description:
        'Find jobs, hire verified talent, and book local services on a map—with messaging and tracked orders in one app. Download Workmorr on iPhone or Android.',
      ogTitle: 'Workmorr — Jobs, talent & local services',
      isLanding: true,
    },
  },
  {
    path: '/read/1/support/privacy-policy',
    name: 'read-privacy',
    component: PageView,
    meta: {
      title: 'Privacy Policy',
      description:
        'Workmorr privacy policy: how we collect, use and protect your information when you use our platform.',
      cmsId: '1',
    },
  },
  {
    path: '/read/2/support/terms-of-use',
    name: 'read-terms',
    component: PageView,
    meta: {
      title: 'Terms of Use',
      description:
        'Terms of use for Workmorr — the rules for using our platform to find jobs, offer services, and connect with others.',
      cmsId: '2',
    },
  },
  {
    path: '/read/:id/:slug(.*)',
    name: 'read',
    component: PageView,
    meta: {
      title: 'Workmorr',
    },
  },
  {
    path: '/404',
    name: '404',
    component: NotFound404View,
    meta: {
      title: 'Page not found',
      description: 'The page you requested is not on Workmorr. Return home to download the app.',
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: LogoutView,
    meta: {
      title: 'Logout',
    },
  },
  {
    path: '/password/forgot',
    name: 'initiate-forgot-password',
    component: ForgotPasswordView,
    meta: {
      title: 'Forgot Password',
    },
  },
  {
    path: '/password/reset/:reset_code',
    name: 'reset-forgotten-password',
    component: ResetPasswordView,
    meta: {
      title: 'Reset Password',
    },
  },
  {
    path: '/v/:user_id/:verification_code?',
    name: 'verify-phone',
    component: VerifyView,
    meta: {
      title: 'Verify Phone',
    },
  },
  {
    path: '/login',
    redirect: '/',
  },
  {
    path: '*',
    redirect: '/',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

const DEFAULT_TITLE = 'Workmorr — Jobs, talent & local services'

router.afterEach((to) => {
  Vue.nextTick(() => {
    const piece = to.meta.title
    document.title =
      to.meta.documentTitle != null
        ? to.meta.documentTitle
        : piece
          ? `Workmorr — ${piece}`
          : DEFAULT_TITLE
    applyRouteSeo(to)
  })
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
